export var getMerchantRepresentativeId = function (merchantDetails) {
    return merchantDetails.representative[0].id;
};
